import React from 'react';
import ResponsivePlayer from '../video/responsivePlayer';
import "../../css/font-awesome.min.css";
import "../../css/elegant-font-icons.css";
import "../../css/elegant-line-icons.css";
import "../../css/bootstrap.min.css";
import "../../css/animate.min.css";
import "../../css/venobox/venobox.css";
import "../../css/owl.carousel.css";
import "../../css/main.css";
import "../../css/responsive.css";
import { Helmet } from "react-helmet";
import darkLogo from "../../img/logo-dark.png";
import clueCap from "../../img/newCClogo.png";
import product1 from "../../img/product-1.png";
import small from "../../img/small.png";
import ccTimeline from '../../img/newTimeline.png';
import im from '../../img/imag.png';
import "./mainPage.css";
import { Container, Row, Col, Form, Button, Image} from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import { withRouter } from 'react-router-dom';
import { method } from "./mainPageService";
import Loader from "react-loader-spinner";
import 'boxicons';
import { BrowserView, MobileView, isMobile } from 'react-device-detect';
import ReactGA from 'react-ga'

ReactGA.initialize('UA-218915160-1')
ReactGA.pageview("/mainPage")

class MainPage extends React.Component {
    constructor(context) {
        super(context);
		this.state = {
			isOpen: false,
			email: '',
			isLoading: false,
		}
		this.openModal = this.openModal.bind(this)
		this.handleClick = this.handleClick.bind(this)
		this.closeModal = this.closeModal.bind(this)
	}
	handleSubmit = (event) => {
		event.preventDefault();
		this.setState({ isLoading: true })
		const form = event.currentTarget;
		if (form.checkValidity() === false) {
			event.preventDefault();
			event.stopPropagation();
		} else {
			const text = {
				email: this.state.email,
			};
			var that = this;
			method(text)
				.then(function (response) {
					that.setState({ isLoading: false })

					 if (response.status == '200') {
						that.setState({ isLoading: false })
						alert('Thank you for subscribing! We will keep you updated.');
						 return response.json();
						 window.location.reload();
					}
					else if (response.status == '400') {
						that.setState({ isLoading: false })
						alert('sorry system down or already subscribed');
						return response.json();
					}
					 else {

						 alert('sorry system down please try again later');
						 window.location.reload();
					 }
			
				}, (error) => {
					if (error) {
						alert('sorry system down or email already confirmed');
						this.setState({
							isLoading: false
						})

					}
				}
				);
		}

		this.setState({ validate: true })
	};

	handleChange = (event) => {
		const { name, value } = event.target;
		this.setState({
			[name]: value,
		});
	};
	openModal() {
		this.setState({ isOpen: true })
	}

	closeModal() {
		this.setState({ isOpen: false })
	
	}
	componentDidMount() {
		ReactGA.initialize('G-KCJ3BWTN18');
		ReactGA.pageview("/mainPage");
	}

	handleClick(e) {
		e.preventDefault();
		this.props.history.push('/story')
	}

	render() {
		var url = "https://lh3.googleusercontent.com/eFQor6fo9S6HyDbNTVp5N8w_0awrYfOkvhZPD_tK12rfhJTpJpRfr5b3woJq5jxtULu6-9lDGcQu39zyYAxSMikIdmbfFHlLgZECrnkOEsiSY1vLddjbrxuA-_valfOSLaCV2A_QtxJK6VAuIo_O1oso2-tLLzpgPkNobeREVOhCDhO9gcnAvMQpkfNfO9q7tUJIK4V3eD141bVukLH2e4_MZpVNsABJee7JlqzyfxFSnktLRp1pqyFXTLwU0kj0E3DledIVsghh8uHE9m55QQ4lyK5VxWFcjulRzT1AYBd_UsvKRbbpxTA-h5an1BWqeYjmrVS-C99p36k2-WG9ZewRPS0Ay346OCHfIekXtpEloToCQMX2SNMO__nWpM0Sy_KyC8YQvBlxnpGu9M-si_-2SJSOEYfP2-GElklSaqdM5Jv3ynQDvflbMrWCXEPmtul4N7pwvj3SGQuE7yGZWq7wPwX5YKBjc5f2JSVZRCMEgWY0d4GqYHykHQcLvUdtp79Wz8KmLrsRbIWmBq8f2usO_Zx6S_8UKgmTs2SiXOT-eoQIXlCyArtTywsW-FkrAhE7XFFfAq-9joKyD0J98a8VM2H5MOmyOCwtJc7u1WlB1aUGpjoKJNtB-b0mZxvIce7GSmZIchbgQc3JoAn5UJj1dPRbKMmmcIgVsBXYUWks5rDhtd88N6vnEeEAMQqUxFn3QZU8qZVzPzdamws6yGZA=w1666-h937-no?authuser=0"
        return (
			<React.Fragment>
{
	<div id="video" className="promo_section  bd-top bd-bottom padding">
	<div className="container">
		<br></br>
		<br></br>
		<br></br>
		<ResponsivePlayer />
		<br></br>
		<br></br>
		<br></br>
		<ul className="why_item">
			<li className="col-md-4 col-xs-6">
				<div className="why_list wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="2000ms">
					<img src="https://res.cloudinary.com/logic-pill/image/upload/v1746298583/Jeremiah_Mora_s_Video_-_May_2_2025-VEED_pqqllo.gif" alt="Stock" width="100%" ></img>
					<h3>Cigar Cutter + Cigar Stand</h3>
					<p>The Turtle Cutter combines both the functionality of a cigar cutter and cigar stand.</p>
				</div>
			</li>
			<li className="col-md-4 col-xs-6">
				<div className="why_list wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="2000ms">
					<img src="https://res.cloudinary.com/logic-pill/image/upload/v1746298569/Jeremiah_Mora_s_Video_-_May_2_2025-VEED_1_hpc6vn.gif" alt="Stock" width="100%" ></img>
					<h3>Clean Smoking Experience</h3>
					<p>The shell of the Turtle Cutter will always catch the cap of your cigar after you cut it. You can also set your cigar on the shell.</p>

				</div>
			</li>

			<li className="col-md-4 col-xs-6">
				<div className="why_list wow fadeInLeft" data-wow-delay="400ms" data-wow-duration="2000ms">
					<img src="https://res.cloudinary.com/logic-pill/image/upload/v1746298641/jared43-ezgif-VEED_pvsrsd.gif" alt="Stock" width="100%" ></img>
					<h3>65 Gauge Cutter</h3>
					<p>Cut any cigar up to 65 gauge with its guillotine straight cutter.</p>
				</div>
			</li>
		</ul>

	</div>
</div>
}
<section id="subscribe" className="subscribe_section bd-bottom">
			<div className="container">
			<div className="section_heading mb-20 align-center">
			{isMobile ? < img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_300/v1746298505/Jeremiah_Mora_s_Video_-_May_3_2025-VEED_1_tuf5p6.gif" alt="Product Image" ></img> :
							< img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_500/v1746298505/Jeremiah_Mora_s_Video_-_May_3_2025-VEED_1_tuf5p6.gif" alt="Product Image" ></img>}										
                  <br></br>
				  <br></br>
				   <h2>Sign up to recive release updates</h2>
                    <p>We will send you news about our updates and release schedule</p>

               </div>	
               <div className="subscribe_wrap">
							<Form action="#" className="subscribe_form" validated={this.state.validate} onSubmit={this.handleSubmit}>
			
								
										<Form.Group>			
									<input type="email" className="form_input" placeholder="Enter Your Email Address..." name="email" id="subs-email" value={this.state.email} onChange={this.handleChange} required></input>
									<button type="submit" className="submit">Subscribe{this.state.isLoading && <span style={{ position: "absolute" }}><Loader
										type="BallTriangle"
										color="white"
										height={50}
										width={50}
									/></span>}</button>
									
									
								
											<div className="clearfix"></div>
											<div id="subscribe-result">
												<p className="subscription-success"></p>
												<p className="subscription-error"></p>
											</div>
										</Form.Group>
								
					
							
							</Form>
					
                </div>
                <ul className="social_link">
							<li><a href="https://www.facebook.com/profile.php?id=61575094924969"><i className="fa fa-facebook"></i></a></li>
							<li><a href=""><i className="fa fa-twitter"></i></a></li>
																	<li><a href="https://www.facebook.com/profile.php?id=61575094924969"><i className="fa fa-tumblr"></i></a></li>
																	<li><a href="#"><i className="fa fa-google-plus"></i></a></li>
																	<li><a href="https://www.instagram.com/turtlecutter/"><i className="fa fa-instagram"></i></a></li>
																	<li><a href="#"><i className="fa fa-pinterest"></i></a></li>
                </ul>
			</div>
			
		</section>
			
				<section id="purchase" className="discount_section bg-grey bd-bottom padding">
					<div className="container">
						<div className="col-sm-6 xs-padding">
							<div className="discount_content wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="2000ms">
								<h2>Please support our kickstarter and be one of the first to get a 40% discount!</h2>
								<p>Please support our Kickstarter to help us fund this project.</p>
								<a target="_blank" rel="noopener noreferrer" href="https://www.kickstarter.com/projects/jsm88/the-turtle-cutter-a-new-kind-of-cigar-cutter" className="default_btn">Go to Kickstarter</a>
							</div>
						</div>
						<div className="col-sm-6 xs-padding">
							<div className="discount_moc wow fadeInRight" data-wow-delay="400ms" data-wow-duration="2000ms">
								<img src="https://res.cloudinary.com/logic-pill/image/upload/v1742740513/jared5-ezgif.com-video-to-gif-converter_lmvsoz.gif" alt="Feature Mockup"></img></div>
						</div>
					</div>
				</section>
				<section id="features" className="feature_section bg bd-bottom padding">
					<div className="feature_moc hidden-xs"></div>
					<div className="container">
						<div className="section_heading align-center mb-40">
							<h2>Turtle Cutter Features</h2>
							<p>Portable Cutter, Clean Cut, Sleek Design, Affordable Price</p>
						</div>
						<div className="row">
							<div className="col-sm-4 xs-padding">
								<ul className="feature_items">
									<li className="feature_item wow fadeInRight" data-wow-delay="0ms" data-wow-duration="2000ms">
									
										<h3>Portable Cutter</h3>
										<p>Set your cigar on the shell whenever you need.</p>
									</li>
									<li className="feature_item wow fadeInRight" data-wow-delay="200ms" data-wow-duration="2000ms">
										
										<h3>Clean Cut</h3>
										<p>Whenever you cut your cigar, the cap falls right in the shell. Its design ensures a clean smoking experience every time.</p>
									</li>
								</ul>
							</div>
							<div className="col-sm-4">
								<div className="feature_moc wow zoomIn" data-wow-delay="0ms" data-wow-duration="2000ms">
									<img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_300/v1746720728/TurtleCutter.update-modified-modified_uknqfa.png"alt="Stock" ></img>
								</div>
							</div>
							<div className="col-sm-4 xs-padding">
								<ul className="feature_items inverted">
									<li className="feature_item wow fadeInLeft" data-wow-delay="0ms" data-wow-duration="2000ms">
									
										<h3>Sleek Design</h3>
										<p>The Turtle Cutter is unique and the first of its kind. It's designed for smoking on the go if you don't like to litter.</p>
									</li>
									<li className="feature_item wow fadeInLeft" data-wow-delay="200ms" data-wow-duration="2000ms">
										
									<h3>65 Gauge Guillotine Straight Cutter</h3>
										<p>The cutter can cut most cigar sizes.</p>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</section>




				<section id="products" className="product_section bg-grey bd-bottom padding">
					<div className="container">
						<div className="section_heading align-center mb-40">
							<h2>How to get one?</h2>
							<p><a href="https://www.kickstarter.com/projects/jsm88/the-turtle-cutter-a-new-kind-of-cigar-cutter">Please visit our Kickstarter now!</a></p>
							<h3>The Timeline</h3>
							<br></br>
							{isMobile ? < img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_251/v1743285228/Untitled_2_etmg2k.png" alt="Product Image" ></img> :
							< img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_490/v1743285228/Untitled_2_etmg2k.png" alt="Product Image" ></img>}
							
                </div>
						
            </div> 
				</section>

				<section id="faq" className="faq_section bd-bottom padding">
					<div className="heading align-center mb-40">
						<h2>Turtle Cutter FAQ</h2>
						<p>Here are some Q&As about our new product</p>
						{isMobile ? < img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_137/v1742742336/Screenshot_2025-02-01_193731_frde9g.png" alt="Product Image" ></img> :
							< img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_333/v1742742336/Screenshot_2025-02-01_193731_frde9g.png" alt="Product Image" ></img>}
					</div>

					<br></br>
            <div className="container">
							<div className="col-md-4 col-xs-6 sm-padding">
								<div className="faq_list">
									<h3>What is the Turtle Cutter?</h3>
									<p>The Turtle Cutter is a portable cigar cutter and cigar stand in one!</p>
								</div>
							</div>
							<div className="col-md-4 col-xs-6 sm-padding">
								<div className="faq_list">
									<h3>What are the parts?</h3>
									<p>The Turtle Cutter has a plastic shell and metal blades.</p>
								</div>
							</div>
							<div className="col-md-4 col-xs-6 sm-padding">
								<div className="faq_list">
									<h3>How does it work?</h3>
									<p>When you cut your cigar, the cap will automatically fall into the shell. Then you can also sit your cigar on the shell if needed.</p>
								</div>
							</div>
						</div>
        </section>
		<section id="faq" className="faq_section bd-bottom padding">
		<div className="heading align-center mb-40">
						<h2></h2>
						<p></p>
						{isMobile ? < img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_300/v1746720773/oneofakindunmerged_yonamw.png" alt="Product Image" ></img> :
							< img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_500/v1746720773/oneofakindunmerged_yonamw.png" alt="Product Image" ></img>}
					</div>
		</section>
				<div className="sponsor_section bg-grey bd-bottom">
					<div className="container">
						<ul id="sponsor_carousel" className="sponsor_items owl-carousel">
							<li className="sponsor_item">
                        <img src="img/sponsor-1.png" alt="sponsor-image"></img>
                    </li>
								<li className="sponsor_item">
								<img src={product1} alt="sponsor-image"></img>
                    </li>
									<li className="sponsor_item">
								<img src={product1} alt="sponsor-image"></img>
                    </li>
										<li className="sponsor_item">
								<img src={product1} alt="sponsor-image"></img>
                    </li>
											<li className="sponsor_item">
								<img src={product1} alt="sponsor-image"></img>
                    </li>
												<li className="sponsor_item">
								<img src={product1} alt="sponsor-image"></img>
                    </li>
													<li className="sponsor_item">
								<img src="img/sponsor-3.png" alt="sponsor-image"></img>
                    </li>
														<li className="sponsor_item">
								<img src="img/sponsor-4.png" alt="sponsor-image"></img>
                    </li>
                </ul>
            </div>
        </div>
        
											

		<footer className="footer_section bg-grey align-center">
             <div className="container">
				<p>&copy; 2021 From Logic Pill</p>
			</div>
		</footer>

		<a data-scroll href="#home" id="scroll-to-top"><i className="arrow_carrot-up"></i></a>
				</React.Fragment>
        );
    }
}

export default withRouter(MainPage);

//{
//	!isMobile ? < section id="home" className="hero_section">
//		<div className="container">
//			<div className="watch_moc hidden-xs"></div>
//			<div className="display-table">
//				<div className="table-cell">
//					<div className="hero_content">
//						<h1>Introducing Clue Cap</h1>
//						<p>A new key attachment to help prevent us from leaving our keys in the door lock <br></br></p>
//						<a target="_blank" rel="noopener noreferrer" href="https://www.kickstarter.com/projects/jsm88/clue-cap-a-new-kind-of-key-mod" className="default_btn">Support us on Kickstarter</a>
//					</div>
//				</div>
//			</div>
//		</div>
//	</section> : < section id="home" className="hero_section">
//		<br></br>
//		<br></br>
//		<div className="container">
//			<div className="watch_moc hidden-xs"></div>
//			<div className="display-table">
//				<div className="table-cell">

//					<div className="hero_content">
//						<img src="https://res.cloudinary.com/logic-pill/image/upload/c_scale,w_320/v1643754518/ccolorsw_ruiadv.jpg" width="100%" alt="Mora_V1_Rendering_3 (1)"></img>
//						<br></br>
//						<br></br>
//						<div className="section_heading align-center">
//							<h3>Clue Cap: A New Kind of Key Mod</h3>

//						</div>
//					</div>

//				</div>
//			</div>
//		</div>
//	</section>
//}